import { RStatus } from "./RStatus";

export interface CommonState<T> {
  loading: boolean;
  total: number;
  data: T;
  error?: Error;
  status: RStatus;
}

export const CommonBuilder = {
  /**
   * 状态初始化
   * @param data 数据源
   * @param total 数据总量
   */
  init<T>(data: T, total: number = 0): CommonState<T> {
    return {
      loading: false,
      error: undefined,
      data,
      total,
      status: RStatus.Init
    };
  },

  /**
   * 请求中状态
   * @param data 数据源
   * @param total 数据总量
   */
  process<T>(data: T, total: number = 0): CommonState<T> {
    return {
      loading: true,
      error: undefined,
      data,
      total,
      status: RStatus.Pending
    };
  },

  /**
   * 请求成功后
   * @param data 数据源
   * @param total 数据总量
   */
  success<T>(data: T, total: number = 0): CommonState<T> {
    return {
      loading: false,
      error: undefined,
      data,
      total,
      status: RStatus.Fulfilled
    };
  },

  /**
   * 请求失败
   * @param data 数据源
   * @param total 数据总量
   */
  failed<T>(error: Error, data: T = [] as any): CommonState<T> {
    return {
      loading: false,
      error,
      data,
      total: 0,
      status: RStatus.Rejected
    };
  }
};

export default CommonBuilder;
